import "react";
import e from "prop-types";
import { css as r, cx as n } from "@leafygreen-ui/emotion";
import { palette as t } from "@leafygreen-ui/palette";
import a from "@leafygreen-ui/icon/dist/Bulb";
import i from "@leafygreen-ui/icon/dist/ImportantWithCircle";
import o from "@leafygreen-ui/icon/dist/InfoWithCircle";
import l from "@leafygreen-ui/icon/dist/Warning";
import p from "@leafygreen-ui/icon/dist/Beaker";
import { Overline as d, Subtitle as s } from "@leafygreen-ui/typography";
import { BaseFontSize as c } from "@leafygreen-ui/tokens";
import { jsx as u } from "@emotion/react";

function b(e, r, n) {
  return r in e ? Object.defineProperty(e, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = n, e;
}

function g(e, r) {
  return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}

var x,
    m,
    f,
    h,
    y,
    k,
    v,
    w,
    N,
    O,
    W,
    z,
    I,
    T,
    j = {
  Note: "note",
  Tip: "tip",
  Important: "important",
  Warning: "warning",
  Example: "example"
},
    E = r(x || (x = g(["\n  font-family: Euclid Circular A, ‘Helvetica Neue’, Helvetica, Arial, sans-serif; // TODO: Refresh – update to fontFamilies.default\n  background-color: ", ";\n  border-radius: 16px;\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: 16px;\n    left: -2px;\n    top: -2px;\n    bottom: -2px;\n    border-radius: 16px 0px 0px 16px;\n  }\n"])), t.white),
    C = r(m || (m = g(["\n  padding: 12px 24px 12px 52px;\n  position: relative;\n  text-transform: uppercase;\n  width: 100%;\n  border-top-left-radius: 14px;\n  border-top-right-radius: 14px;\n"]))),
    F = r(f || (f = g(["\n  left: 20px;\n  position: absolute;\n"]))),
    R = r(h || (h = g(["\n  font-weight: 600;\n  letter-spacing: inherit;\n  color: inherit;\n"]))),
    q = r(y || (y = g(["\n  display: flex;\n  flex-direction: column;\n  padding: 16px 24px 16px 52px;\n  font-weight: 400;\n"]))),
    A = (b(w = {}, 13, r(k || (k = g(["\n    font-size: 13px;\n    line-height: 20px;\n  "])))), b(w, 16, r(v || (v = g(["\n    font-size: 16px;\n    line-height: 28px;\n  "])))), w),
    B = (b(N = {}, j.Note, "Note"), b(N, j.Tip, "Tip"), b(N, j.Important, "Important"), b(N, j.Warning, "Warning"), b(N, j.Example, "Example"), N),
    H = (b(O = {}, j.Note, o), b(O, j.Tip, a), b(O, j.Important, i), b(O, j.Warning, l), b(O, j.Example, p), O),
    P = (b(W = {}, j.Note, {
  header: {
    background: t.blue.light3,
    text: t.blue.dark1
  },
  text: t.blue.dark3,
  bar: t.blue.base,
  icon: t.blue.base,
  border: t.blue.light2
}), b(W, j.Tip, {
  header: {
    background: t.purple.light3,
    text: t.purple.dark2
  },
  text: t.purple.dark3,
  bar: t.purple.base,
  icon: t.purple.base,
  border: t.purple.light2
}), b(W, j.Important, {
  header: {
    background: t.yellow.light3,
    text: t.yellow.dark2
  },
  text: t.yellow.dark3,
  bar: t.yellow.base,
  icon: t.yellow.dark2,
  border: t.yellow.light2
}), b(W, j.Warning, {
  header: {
    background: t.red.light3,
    text: t.red.dark2
  },
  text: t.red.dark3,
  bar: t.red.base,
  icon: t.red.base,
  border: t.red.light2
}), b(W, j.Example, {
  header: {
    background: t.gray.light2,
    text: t.gray.dark2
  },
  text: t.gray.dark3,
  bar: t.gray.dark1,
  icon: t.gray.dark3,
  border: t.gray.light1
}), W);

function S(e) {
  var t = e.variant,
      a = e.title,
      i = e.baseFontSize,
      o = void 0 === i ? 13 : i,
      l = e.className,
      p = e.children,
      c = P[t],
      b = H[t];
  return u("div", {
    role: "note",
    className: n(E, r(z || (z = g(["\n          color: ", ";\n          border: 2px solid ", ";\n          box-shadow: inset 0px 2px 0px 0px ", "; // hides gap between the border and the header div when zoomed in.\n\n          &:after {\n            background: linear-gradient(\n              to left,\n              transparent 9px,\n              ", " 9px\n            );\n          }\n        "])), c.text, c.border, c.header.background, c.bar), l)
  }, u("div", {
    className: n(C, r(I || (I = g(["\n            background-color: ", ";\n            color: ", ";\n          "])), c.header.background, c.header.text))
  }, u(b, {
    fill: c.icon,
    className: F,
    role: "presentation"
  }), u(d, {
    as: "h2",
    className: n(r(T || (T = g(["\n              color: inherit;\n              letter-spacing: 0.6px;\n            "]))))
  }, B[t])), u("div", {
    className: q
  }, a && u(s, {
    as: "h3",
    className: n(R, A[o])
  }, a), u("div", {
    className: A[o]
  }, p)));
}

S.propTypes = {
  variant: e.oneOf(Object.values(j)).isRequired,
  title: e.string,
  children: e.node.isRequired,
  className: e.string,
  baseFontSize: e.oneOf(Object.values(c))
};
export { j as Variant, S as default };